import React, { useState } from "react"
import { capitalize } from "../../../../lib"
import moment from "moment"
import styles from "./Days.scss"

interface IProps {
  month: number
  year: number
  firstDayOfMonth: number
  closeDrawer: () => void
  setStartDate: (date: Date) => void
  setEndDate: (date: Date) => void
  setdateSelectionIndex: (index: boolean) => void
  dateSelectionIndex: boolean
  startDate: Date
  endDate: Date
}

const DrawerDays = ({
  month,
  year,
  firstDayOfMonth,
  setStartDate,
  setEndDate,
  setdateSelectionIndex,
  dateSelectionIndex,
  startDate,
  endDate
}: IProps) => {
  function isPastDate(day: number) {
    const currentDate = moment()
      .year(year)
      .month(month)
      .date(day)
    return moment(moment()).isAfter(currentDate)
  }

  function handleTdClick(e) {
    if (e && e.target && e.target.innerHTML) {
      const clickedDay = e.target.innerHTML
      const selectedDate = moment()
        .year(year)
        .month(month)
        .date(clickedDay)

      if (selectedDate.isSameOrBefore(startDate) || !startDate) {
        setStartDate(selectedDate)
        setdateSelectionIndex(true)
      } else if (!dateSelectionIndex) {
        setStartDate(selectedDate)
        setEndDate(undefined)
        setdateSelectionIndex(true)
      } else {
        setEndDate(selectedDate)
        setdateSelectionIndex(false)
      }
    }
  }

  function areDatesTheSame(firstDate, secondDate) {
    if (!firstDate || !secondDate) {
      return false
    }
    return (
      firstDate.isSame(secondDate, "day") &&
      firstDate.isSame(secondDate, "month") &&
      firstDate.isSame(secondDate, "year")
    )
  }

  function useProperClassName(isPastDay: boolean, correctedDay: number) {
    const createdDate = moment()
      .year(year)
      .month(month)
      .date(correctedDay)

    if (isPastDay) {
      return "disabled"
    } else if (
      areDatesTheSame(createdDate, startDate) ||
      areDatesTheSame(createdDate, endDate)
    ) {
      return "selected"
    } else if (createdDate.isBetween(startDate, endDate)) {
      return "between"
    }
    return "default"
  }

  function renderWeek(week: number, maxDay: number) {
    const days = []

    if (week === 0 && firstDayOfMonth > 0) {
      for (let i = 0; i < firstDayOfMonth; i++) {
        days.push(<td key={i} className="invisible" />)
      }
    }

    for (let i = 0; days.length < 7; i++) {
      if (week * 7 + i + 1 > maxDay + firstDayOfMonth) {
        days.push(<td key={days.length} className={"invisible"} />)
      } else {
        const day = week * 7 + i + 1
        const correctedDay = week > 0 ? day - firstDayOfMonth : day
        const isPastDay = isPastDate(day)
        const className = useProperClassName(isPastDay, correctedDay)
        days.push(
          <td
            key={days.length}
            onClick={isPastDay ? () => {} : handleTdClick}
            className={className}
          >
            {correctedDay}
          </td>
        )
      }
    }

    return days
  }

  function renderMonth() {
    const rows = []
    const maxDay = moment()
      .month(month)
      .daysInMonth()

    for (let i = 0; i * 7 < maxDay + firstDayOfMonth; i++) {
      rows.push(<tr key={i}>{renderWeek(i, maxDay)}</tr>)
    }
    return rows
  }

  function renderDaysHeader() {
    const daysName = []
    const current = moment()

    for (let i = 0; i < 7; i++) {
      daysName.push(
        <th id="dayName" key={i}>
          {capitalize(current.day(i).format("dd"))}
        </th>
      )
    }
    return <tr id="daysHeaderRow">{daysName}</tr>
  }
  return (
    <table className={styles.container}>
      <tbody>
        {renderDaysHeader()}
        {renderMonth()}
      </tbody>
    </table>
  )
}

export default DrawerDays
